import axiosInstance from "./AxiosInstance";

class PoliticalPartyUsersService {
	constructor() {
		this.endpoint = "api/politicalparties/users";
	}

	async getAll(params) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}`, {
				params
			});

			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async getByID(id) {
		try {
			const response = await axiosInstance.get(`${this.endpoint}/${id}`);
			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			throw error;
		}
	}

	async update(id, payload) {
		try {
			const response = await axiosInstance.patch(`${this.endpoint}/${id}`, payload);
			return response.data;
		} catch (error) {
			console.error("Error updating user:", error);
		}
	}

	async create(payload) {
		try {
			const response = await axiosInstance.post(`${this.endpoint}`, payload);
			return response.data;
		} catch (error) {
			console.error("Error creating user:", error);
		}
	}

	async delete(id) {
		try {
			const response = await axiosInstance.delete(`${this.endpoint}/${id}`);
			return response.data;
		} catch (error) {
			console.error("Error deleting user:", error);
		}
	}
}

const politicalPartyUsersService = new PoliticalPartyUsersService();

export { politicalPartyUsersService };
